import { jsx as s, jsxs as v } from "react/jsx-runtime";
import { forwardRef as G, useState as P, useRef as k, useImperativeHandle as S, useEffect as E, useLayoutEffect as W } from "react";
import { createPortal as N } from "react-dom";
import { useBreakpoint as Y } from "./components/Breakpoint/BreakpointProvider.js";
import { d as C } from "./DropDownMLP1.module-6ac9e835.mjs";
import { d as V } from "./DropDownMLP2.module-5507795f.mjs";
import { isElementEmpty as A, getContainerPortalId as L } from "./utils/index.js";
import { DEFAULT_PORTAL_CONTAINER_ID as I } from "./types/enums.js";
import M from "./hooks/useClickOutsideDetector.js";
import "./components/Modal/types/enums.js";
import './assets/RawModal.css';const D = "#ffffff", H = "#396e75", T = "#e5fdff", j = "#546223", F = "#f0fae5", U = "#a65523", J = "#fff1e8", K = "#7f3e3e", Q = "#ffe2e2", X = "#62625a", Z = "#f8f8e7", aa = "#38539a", ta = "#707070", oa = "#c8f8d1", ea = "#87c9c8", na = "#5291b1", ra = "rgba(82, 145, 177, 0.1019607843)", da = "#445685", ia = "#181d61", la = "rgba(24, 29, 97, 0.1019607843)", ca = "#5969d6", sa = "#ea999d", _a = "#b6577e", ua = "rgba(182, 87, 126, 0.1019607843)", ma = "#7e3e80", fa = "#1e247f", ga = "rgba(30, 36, 127, 0.1019607843)", ha = "#da7600", pa = "#107f47", za = "#d91734", ka = "_html_1axq1_34", w = {
  amwayWhite: D,
  darkBlue: H,
  lightBlue: T,
  darkGreen: j,
  lightGreen: F,
  darkOrange: U,
  lightOrange: J,
  darkRed: K,
  lightRed: Q,
  darkYellow: X,
  lightYellow: Z,
  darkPurple: aa,
  darkGrayOnWhite: ta,
  dataVizColor1: oa,
  dataVizColor2: ea,
  dataVizColor3: na,
  dataVizColor3Background: ra,
  dataVizColor4: da,
  dataVizColor5: ia,
  dataVizColor5Background: la,
  dataVizColor6: ca,
  dataVizColor7: sa,
  dataVizColor8: _a,
  dataVizColor8Background: ua,
  dataVizColor9: ma,
  dataVizColor10: fa,
  dataVizColor10Background: ga,
  dataVizAlertOrange: ha,
  dataVizSuccessGreen: pa,
  dataVizWarningRed: za,
  html: ka,
  "date-picker-container": "_date-picker-container_1axq1_68",
  "date-picker-container-within-modal": "_date-picker-container-within-modal_1axq1_69",
  "mlp-version-2": "_mlp-version-2_1axq1_70",
  "input-label": "_input-label_1axq1_74",
  "date-picker-tool-tip": "_date-picker-tool-tip_1axq1_90",
  "required-indicator": "_required-indicator_1axq1_98",
  "icon-close": "_icon-close_1axq1_103",
  "menu-container": "_menu-container_1axq1_111",
  "default-width": "_default-width_1axq1_127",
  "full-width": "_full-width_1axq1_133",
  "within-drawer": "_within-drawer_1axq1_133",
  "calendar-header": "_calendar-header_1axq1_146",
  "calendar-header-title": "_calendar-header-title_1axq1_157",
  "description-container": "_description-container_1axq1_176",
  "calendar-body": "_calendar-body_1axq1_187",
  "datepicker-modal-header-section": "_datepicker-modal-header-section_1axq1_192",
  "modal-icon-section": "_modal-icon-section_1axq1_203",
  "modal-headline": "_modal-headline_1axq1_208",
  "input-container": "_input-container_1axq1_213",
  "datepicker-default": "_datepicker-default_1axq1_229",
  "input-container-active": "_input-container-active_1axq1_235",
  "calendar-modal-container": "_calendar-modal-container_1axq1_248",
  "datepicker-valid": "_datepicker-valid_1axq1_253",
  "datepicker-invalid": "_datepicker-invalid_1axq1_259",
  "datepicker-input-disabled": "_datepicker-input-disabled_1axq1_265",
  "placeholder-container": "_placeholder-container_1axq1_274",
  "calendar-state-open": "_calendar-state-open_1axq1_294",
  "action-button-container": "_action-button-container_1axq1_304",
  "action-button": "_action-button_1axq1_304",
  "primary-action-button": "_primary-action-button_1axq1_324",
  "modal-action-button-container": "_modal-action-button-container_1axq1_329",
  "datePicker-modal-description-container": "_datePicker-modal-description-container_1axq1_335",
  "calendar-icon": "_calendar-icon_1axq1_352",
  "calendar-wrapper": "_calendar-wrapper_1axq1_357",
  "calendar-footer": "_calendar-footer_1axq1_364",
  "calendar-heading": "_calendar-heading_1axq1_372"
}, Ca = "#ffffff", Va = "#396e75", wa = "#e5fdff", ba = "#546223", xa = "#f0fae5", $a = "#a65523", qa = "#fff1e8", ya = "#7f3e3e", Ba = "#ffe2e2", Ra = "#62625a", Oa = "#f8f8e7", va = "#38539a", Ga = "#707070", Pa = "#c8f8d1", Sa = "#87c9c8", Ea = "#5291b1", Wa = "rgba(82, 145, 177, 0.1019607843)", Na = "#445685", Ya = "#181d61", Aa = "rgba(24, 29, 97, 0.1019607843)", La = "#5969d6", Ia = "#ea999d", Ma = "#b6577e", Da = "rgba(182, 87, 126, 0.1019607843)", Ha = "#7e3e80", Ta = "#1e247f", ja = "rgba(30, 36, 127, 0.1019607843)", Fa = "#da7600", Ua = "#107f47", Ja = "#d91734", Ka = "_html_1souu_34", r = {
  amwayWhite: Ca,
  darkBlue: Va,
  lightBlue: wa,
  darkGreen: ba,
  lightGreen: xa,
  darkOrange: $a,
  lightOrange: qa,
  darkRed: ya,
  lightRed: Ba,
  darkYellow: Ra,
  lightYellow: Oa,
  darkPurple: va,
  darkGrayOnWhite: Ga,
  dataVizColor1: Pa,
  dataVizColor2: Sa,
  dataVizColor3: Ea,
  dataVizColor3Background: Wa,
  dataVizColor4: Na,
  dataVizColor5: Ya,
  dataVizColor5Background: Aa,
  dataVizColor6: La,
  dataVizColor7: Ia,
  dataVizColor8: Ma,
  dataVizColor8Background: Da,
  dataVizColor9: Ha,
  dataVizColor10: Ta,
  dataVizColor10Background: ja,
  dataVizAlertOrange: Fa,
  dataVizSuccessGreen: Ua,
  dataVizWarningRed: Ja,
  html: Ka,
  "modal-container": "_modal-container_1souu_68",
  "modal-dialog": "_modal-dialog_1souu_72",
  "close-icon": "_close-icon_1souu_110",
  "modal-headline": "_modal-headline_1souu_115",
  "modal-headline-left": "_modal-headline-left_1souu_124",
  "modal-headline-center": "_modal-headline-center_1souu_127",
  "modal-content-center": "_modal-content-center_1souu_130",
  "modal-content-left": "_modal-content-left_1souu_152",
  "modal-header-section": "_modal-header-section_1souu_174",
  "modal-icon-section": "_modal-icon-section_1souu_181",
  "modal-footer-section": "_modal-footer-section_1souu_196",
  "modal-bottom-container": "_modal-bottom-container_1souu_206",
  "modal-bottom-without-secondary": "_modal-bottom-without-secondary_1souu_215",
  "modal-bottom-no-footer": "_modal-bottom-no-footer_1souu_224",
  "bottom-container": "_bottom-container_1souu_227",
  "modal-button-container": "_modal-button-container_1souu_237",
  "align-horizontal-button": "_align-horizontal-button_1souu_244",
  "align-vertical-button": "_align-vertical-button_1souu_244",
  "text-link": "_text-link_1souu_252",
  "modal-content": "_modal-content_1souu_130",
  "align-default-button": "_align-default-button_1souu_296",
  "primary-button-with-textlink": "_primary-button-with-textlink_1souu_303"
};
function g(o, d, i, _) {
  const l = Array.from(
    o.current.getElementsByClassName(d)
  ), a = Array.from(
    o.current.getElementsByClassName(i)
  );
  a != null && a.length && l.forEach((c, t) => {
    if (a != null && a[t]) {
      const e = c.getBoundingClientRect();
      _ ? (a[t].style.left = `${e.left - o.current.getBoundingClientRect().left}px`, a[t].style.margin = "0") : a[t].style.left = "unset", a[t].style.top = `${e.top - o.current.getBoundingClientRect().top + e.height + 8}px`, a[t].style.right = "unset", a[t].style.position = "fixed", a[t].style.width = `${e.width}px`;
    }
  });
}
const Qa = G(
  ({
    header: o,
    children: d,
    containerWidth: i,
    textAlign: _,
    closeOnBackdropClick: l = !0,
    onClose: a,
    id: c,
    footer: t,
    className: e,
    footerClassname: b,
    useReactPortal: x = !1,
    portalContainerId: $ = I
  }, q) => {
    const [y, B] = P(!1), n = k(), h = k(), R = Y();
    S(q, () => n.current);
    const O = (() => l ? a : void 0)();
    M(n, O, [l], h);
    function u() {
      const f = document.getElementById(`nextgen-modal-content-${c}`);
      f && B(f.scrollHeight > Math.ceil(f.getBoundingClientRect().height));
    }
    E(() => (u(), window.addEventListener("resize", u), () => window.removeEventListener("resize", u)), [d]), W(() => {
      g(
        n,
        V["mlp-2-dropdown-modal"],
        V["dropdown-drawer"],
        !1
      ), g(
        n,
        C["dropdown-container-modal"],
        C["base-dropdown-result"],
        !1
      ), g(
        n,
        w["date-picker-container-within-modal"],
        w["menu-container"],
        !0
      );
    }, [R]);
    let m = r["modal-bottom-without-secondary"];
    y && (m += ` ${r["bottom-container"]}`), (!t || A(t)) && (m += ` ${r["modal-bottom-no-footer"]}`);
    const p = /* @__PURE__ */ s("div", { ref: h, "data-testid": "modal-container-data-testid", "data-pod-name": "fwk", children: /* @__PURE__ */ s("section", { className: r["modal-dialog"], children: /* @__PURE__ */ v(
      "section",
      {
        className: `${r["modal-container"]} ${e}`,
        style: i ? { width: i } : {},
        ref: n,
        children: [
          o,
          /* @__PURE__ */ s(
            "section",
            {
              id: `nextgen-modal-content-${c}`,
              className: r[`modal-content-${_}`],
              "data-testid": "content-test-id",
              "data-pod-name": "fwk",
              "data-allow-scroll": "true",
              children: d
            }
          ),
          /* @__PURE__ */ s("section", { className: `${m} ${b}`, children: t })
        ]
      }
    ) }) }), z = L($);
    return x && z ? N(p, z) : p;
  }
);
Qa.displayName = "RawModal";
export {
  Qa as R,
  w as d,
  r as s
};
//# sourceMappingURL=RawModal-c4d94c63.mjs.map
